import React, {Component,} from 'react'

import * as firebase from 'firebase';
import { connect } from 'react-redux'

import Popover from 'material-ui/Popover';
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';

import ServiceConfig from '../service/ServiceColumnConfig.js';
import PayrollConfig from '../payroll/PayrollConfig.js';

class JobColumnFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allColumnHeaders: [],
      selectedColumnHeaders: [],
      openPopover: false,
      searchFilter: '',
    };
  }

  componentWillMount() {
    if (this.props.currentReport){
      this.setDBPaths(this.props);
      this.initLoaders(this.props);
    }
  }

  componentWillReceiveProps(nextProps){
    if (this.props.currentReport !== nextProps.currentReport){
      this.detachLoaders();
      this.setDBPaths(nextProps);
      this.initLoaders(nextProps);
    }
  }

  componentWillUnmount() {
    this.detachLoaders()
  }

  initLoaders(props){
    this.listener = this.onUpdate.bind(this, props.currentReport)
    this.listenerSelected = this.getCurrentColumns.bind(this, props.currentReport)
    firebase.database().ref(this.dbPathTemplate).on('value', this.listener);
    firebase.database().ref(this.dbPathSelectedColumns + 'list').orderByChild('priority').on('value', this.listenerSelected);
  }

  detachLoaders(props){
    firebase.database().ref(this.dbPathTemplate).off('value', this.listener);
    firebase.database().ref(this.dbPathSelectedColumns + 'list').orderByChild('priority').off('value', this.listenerSelected);
  }

  setDBPaths = (props) => {
    if (props.currentReport === 'serviceSummary'){
      this.dbPathTemplate = `teams/${props.teamId}/templates/events/`;
      this.dbPathSelectedColumns = `users/${props.userAuth.id}/settings/selectedColumns/${props.teamId}/`
      this.config = ServiceConfig;
    } else if (props.currentReport === 'payroll'){
      this.dbPathTemplate = `teams/${props.teamId}/templates/timesheet/`;
      this.dbPathSelectedColumns = `users/${props.userAuth.id}/settings/selectedPayrollColumns/${props.teamId}/`;
      this.config = PayrollConfig;
    }
  }


  onUpdate(currentReport, snapshot) {
    const templates = snapshot.val();
    const values = {};
    const Config = this.config

    //Get all modules from template
    for (const templateKey in templates) {
      Object.keys(templates[templateKey].modules).forEach(modulekey => {
        if (currentReport === 'serviceSummary'){
          values[Config.getModuleKey(modulekey)] = true
        } else if (currentReport === 'payroll'){
          values[modulekey] = true
        }
      })
    }

    const headerOptions = [];

    if (currentReport === 'serviceSummary'){
      //Remove defaults
      let clocking = false, contactInfo = false
      Object.keys(values).forEach(value => {
        // If columnName is not same value as moduleName, or multiple columns are needed for a module, add here-
        if (value.indexOf('clocking') !== -1 && !clocking) {
          //ClockingTeam/ClockExtended columns
          headerOptions.push(Config.modules['actual'])
          headerOptions.push(Config.modules['target'])
          headerOptions.push(Config.modules['clockInOut'])
          clocking = true
        } else if (value === 'contactInfo' && !contactInfo) {
          // contactinfo module needs both contactInfo and contactId module
          headerOptions.push(Config.modules['contactId']);
          headerOptions.push(Config.modules['contactInfo']);
          contactInfo = true
        }
        else if (value === 'date') {
          // Job type uses date module
          headerOptions.push(Config.modules['date'])
          headerOptions.push(Config.modules['jobType'])
        }
        else if (Config.modules[value]) {
          // for all other modules that only require one column which has the same name
          headerOptions.push(Config.modules[value])
        }
      })
    } else if (currentReport === 'payroll'){
      Object.keys(values).forEach(value => {
        // If columnName is not same value as moduleName, or multiple columns are needed for a module, add here-
        if (value === 'clockingDay'){
          headerOptions.push(Config['time'])
          headerOptions.push(Config['loggedHours'])
          headerOptions.push(Config['lunch'])
          headerOptions.push(Config['billableHours'])
          headerOptions.push(Config['bwRatio'])
          headerOptions.push(Config['notes'])
        } else if (Config[value]){
          // for all other modules that only require one column which has the same name
          headerOptions.push(Config[value]);
        }
      })
    }
    this.setState({allColumnHeaders: headerOptions})
  }

  updateFirebaseColumnSelection = (columns) => {
    const updates = {};
    const list = {};
    columns.forEach((column, idx) => {
      list[column] = {
        value: column,
        priority: idx
      }
    })
    updates[this.dbPathSelectedColumns + 'list'] = list;
    firebase.database().ref().update(updates);
  }

  getDefaultViews(currentReport){
    const result = [];
    const Config = this.config;

    if (currentReport === 'serviceSummary'){
      for (let col in Config.modules) {
        
        if (Config.modules[col]['default'] === true && col !== 'index'){
          result.push(Config.modules[col]);
        }
      }
    } else if (currentReport === 'payroll'){
      for (let col in Config){
        if (Config[col]['default'] === true && col !== 'date'){
          result.push(Config[col]);
        }
      }
    }

    result.sort((a, b) => (a.order - b.order))
    return result;
  }

  getCurrentColumns = (currentReport, snapshots) => {
    let selectedColumnHeaders = [];
    snapshots.forEach(snapshot => {
      const columnEntry = snapshot.val();
      if (columnEntry && columnEntry.value){
        selectedColumnHeaders.push(columnEntry.value)
      }
    })

    if (selectedColumnHeaders.length === 0){
      selectedColumnHeaders = this.getDefaultViews(currentReport).map(view => view.key);
      this.updateFirebaseColumnSelection(selectedColumnHeaders);
    }

    this.setState({selectedColumnHeaders});

    if (currentReport === "serviceSummary"){
      this.props.dispatch({
        type: 'REPORTS_SET_HEADERS',
        label: 'SERVICE_HEADERS',
        value: {
          columnHeaders: selectedColumnHeaders.slice(), //copying object by value so redux sense change
        }
      });
    } else if (currentReport === 'payroll'){
      this.props.dispatch({
        type: 'REPORTS_SET_HEADERS',
        label: 'PAYROLL_HEADERS',
        value: {
          columnHeaders: selectedColumnHeaders.slice(), //copying object by value so redux sense change
        }
      });
    }

  }

  onAllColumnsClick(add) {
    let selectedColumnHeaders = [];
    if (add){
      selectedColumnHeaders = this.state.allColumnHeaders.map(value => value.key);
    }

    this.setState({selectedColumnHeaders});
    this.updateFirebaseColumnSelection(selectedColumnHeaders);
  }

  onCheck(columnHeader, add) {
    let selectedColumnHeaders = this.state.selectedColumnHeaders;

    if (add){
      selectedColumnHeaders.push(columnHeader.key);
    } else {
      //indexOf and splice might be faster (not by asymtopic order of mag) but number of options relatively small
      selectedColumnHeaders = selectedColumnHeaders.filter(value => value !== columnHeader.key);
    }

    this.setState({selectedColumnHeaders});
    this.updateFirebaseColumnSelection(selectedColumnHeaders);
  }

  renderItem(columnHeader) {
    const label = columnHeader.label;
    let checkColor = '#8c8c8c';
    const isSelected = this.state.selectedColumnHeaders.indexOf(columnHeader.key) !== -1;

    return (
      <div
        key={columnHeader.key}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: 8,
        }}
        onTouchTap={ (event) => this.onCheck(columnHeader, !isSelected) }>
        <Checkbox
          style={{ width: '24px', alignItems: 'center' }}
          iconStyle={{ fill: checkColor }}
          checked={isSelected}/>
        <span
          style={{fontSize: 16}}>
          {label}
        </span>
      </div>
    );
  }

  renderAllItemsOption() {
    let checkColor = '#8c8c8c';
    const countOfSelected = this.state.selectedColumnHeaders.length;
    const total = this.state.allColumnHeaders.length;
    const isSelected = countOfSelected === total;
    const label = "All";
    return (
      <div
        key={-1}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: 8
        }}
        onTouchTap={(event) => {
          this.onAllColumnsClick(!isSelected);
        }}>
        <Checkbox
          style={{ width: '24px', alignItems: 'center' }}
          iconStyle={{ fill: checkColor }}
          checked={isSelected}/>
        <span
          style={{fontSize: 16}}>
          {label}
        </span>
      </div>
    );
  }

  renderColumnHeaders() {
    const views = [];
    views.push(this.renderAllItemsOption());
    views.push(
      <Divider
        style={{ marginTop: 4, marginBottom: 4 }}
        key='divider'/>
    );

    this.state.allColumnHeaders.forEach((columnHeader) => {
      if (this.state.searchFilter === '' ||
        columnHeader.label.indexOf(this.state.searchFilter) !== -1) {
        views.push(this.renderItem(columnHeader));
      }
    })
    return views;
  }

  renderSearch() {
    return (
      <TextField
        key="text-field"
        style={{ margin: 4, marginTop: 0, width: '100%' }}
        hintText="Search"
        value={this.state.searchFilter}
        onChange={(event, newValue) => this.setState({ searchFilter: newValue })}/>
    )
  }

  render() {
    let buttonLabel = 'Default';
    const countOfSelected = this.state.selectedColumnHeaders.length;
    if (countOfSelected) {
      buttonLabel = `${countOfSelected} Columns`;
    }

    return (
      <div
        style={{ float: 'left', backgroundColor: '#fafafa' }}
        ref='root'>
        <FlatButton
          onTouchTap={(event) => {
            event.preventDefault();
            this.setState({ openPopover: true });
          }}
          style={{ border: '1px solid #e2e2e2', width: 152 }}>
          <span
            style={{
              color: '#4d6f7f',
              textTransform: 'none',
              float: 'left',
              marginLeft: 17,
              fontSize: 14
            }}>
            {buttonLabel}
          </span>
          <FontIcon
            className="material-icons"
            color='#4d6f7f'
            style={{ paddingTop: 5, marginRight: 13, float: 'right' }}>
            keyboard_arrow_down
          </FontIcon>
        </FlatButton>
        <Popover
          open={this.state.openPopover}
          anchorEl={this.refs.root}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={() => this.setState({openPopover: false})}>
          <div
            style={{ maxHeight: 350, padding: 10 }}>
            {this.renderSearch()}
            {this.renderColumnHeaders()}
          </div>
        </Popover>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let allWorkers = [];
  let teamId = undefined;

  const teamInfo = state.firebase.team;
  if (teamInfo){
    if (teamInfo.members && !teamInfo.members.loading) {
      allWorkers = teamInfo.members.value;
    }
    if (teamInfo.metadata && !teamInfo.metadata.loading) {
      teamId = teamInfo.metadata.value.id;
    }
  }

  let type = '';
  if (state.reports && state.reports.uiData){
    type = state.reports.uiData.type;
  }

  return {
    teamId: teamId,
    allWorkers: allWorkers,
    userAuth: state.firebase.userAuth,
    currentReport: type
  }
};
export default connect(mapStateToProps)(JobColumnFilter);



// WEBPACK FOOTER //
// ./src/reports/common/JobColumnFilter.js